import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as assignmentAPI from "../../api/assignment";

const initialState = {
  data: null,
  currentAssignment: null,
  redirect: false,
  loading: false,
  perPage: 10,
  page: 1,
  offset: 0,

  classes: null,
};

const getClasses = createAsyncThunk(
  "assignment/getClasses",
  async (params, { rejectWithValue }) => {
    try {
      const res = await assignmentAPI.getClasses(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const getAssignment = createAsyncThunk(
  "assignment/get",
  async (params, { rejectWithValue }) => {
    try {
      const res = await assignmentAPI.getAssignment(params);
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const addAssignment = createAsyncThunk(
  "assignment/add",
  async (params, { rejectWithValue }) => {
    try {
      const res = await assignmentAPI.addAssignment(params);
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const deleteAssignment = createAsyncThunk(
  "assignment/delete",
  async (params, { rejectWithValue }) => {
    try {
      const res = await assignmentAPI.deleteAssignment(params);
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const updatedAssignment = createAsyncThunk(
  "assignment/update",
  async (params, { rejectWithValue }) => {
    try {
      const res = await assignmentAPI.updateAssignment(params);
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const assignmentSlice = createSlice({
  name: "assignment",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    setCurrentAssignment: (state, action) => {
      const index = state.data?.classAssignment?.findIndex(
        (_el) => _el.id === action.payload
      );
      console.log("setCurrentAssignment", index);
      state.currentAssignment = state.data?.classAssignment?.[index];
    },
    resetCurrentAssignment: (state) => {
      state.currentAssignment = initialState.currentAssignment;
    },
    setRedirect: (state, action) => {
      state.redirect = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: {
    [getAssignment.pending]: (state) => {
      state.loading = true;
    },
    [getAssignment.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [getAssignment.rejected]: (state) => {
      state.loading = false;
    },

    [addAssignment.pending]: (state) => {
      state.loading = true;
    },
    [addAssignment.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action?.payload?.assignmentAdded);
    },
    [addAssignment.rejected]: (state) => {
      state.loading = false;
    },

    [deleteAssignment.pending]: (state) => {
      state.loading = true;
    },
    [deleteAssignment.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [deleteAssignment.rejected]: (state) => {
      state.loading = false;
    },

    [updatedAssignment.pending]: (state) => {
      state.loading = true;
    },
    [updatedAssignment.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [updatedAssignment.rejected]: (state) => {
      state.loading = false;
    },

    [getClasses.pending]: (state) => {
      state.loading = true;
    },
    [getClasses.fulfilled]: (state, action) => {
      state.loading = false;
      state.classes = action.payload;
    },
    [getClasses.rejected]: (state) => {
      state.loading = false;
    },
  },
});

const {
  resetState,
  setCurrentAssignment,
  resetCurrentAssignment,
  setRedirect,
  setPerPage,
  setOffset,
  setPage,
} = assignmentSlice.actions;

export default assignmentSlice.reducer;

export {
  resetState,
  getAssignment,
  addAssignment,
  deleteAssignment,
  updatedAssignment,
  setCurrentAssignment,
  resetCurrentAssignment,
  setRedirect,
  setPerPage,
  setOffset,
  setPage,
  getClasses,
};
